<template>
  <a-config-provider :locale="zh_CN">

      <Header v-if="!isPC"/>
    <a-spin :spinning="spinning">
      <main>
        <router-view />
      </main>

  <!--    <Footer />-->

      <!-- 回到顶部 -->
      <a-back-top>
        <div class="backTop">
          <UpOutlined />
        </div>
      </a-back-top>
    </a-spin>
  </a-config-provider>
</template>

<script>
import Cookie from "js-cookie";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { UpOutlined } from "@ant-design/icons-vue";
import Header from "@c/Header";
import Footer from "@c/Footer";
import { BackTop, ConfigProvider, Spin } from "ant-design-vue";
import { isBrainMedPC } from "@/utils/methods.js";

export default {
  name: "index",
  components: {
    Header,
    Footer,
    [BackTop.name]: BackTop,
    [ConfigProvider.name]: ConfigProvider,
    [Spin.name]: Spin,
    UpOutlined,
  },
  computed: {
    spinning_cpu () {
      return this.$store.state.spinning;
    }
  },
  data() {
    return {
      zh_CN,
      spinning: false,
      isPC: false,
    };
  },
  // 切换页面将滚动跳恢复至顶部
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // 页面加载状态
    spinning_cpu: {
      handler (newV, oldV) {
        this.spinning = newV
      },
    }
  },
  created() {
    if(Cookie.get('medtion_user_only_sign')){
      let userInfo = JSON.parse(Cookie.get('medtion_user_only_sign'));
      if(userInfo.identity === 7){
        // 这里只是为了防止header闪烁
        this.isPC = true;
        window.location.href='/access-restriction';
      }
    }
  },
  mounted() {
    if(isBrainMedPC()){
      this.isPC = true;
    }
  }
};
</script>

<style lang="scss">
#app {
  background: #ffffff;
}
main{
  padding-bottom: 30px;
}
.backTop {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d1d6dc;
  color: #fff;
  font-size: 24px;
  border-radius: 6px;
  transition: all 0.3s;

  &:hover {
    background: $theme_blue;
  }
}
</style>
